import { useQuery } from '@apollo/client/react';
import { DocumentMetadataPropertyReferenceEnum } from 'shared/domains/apollo/generated/types';
import { AddMetadataReferenceUserSelectionDocument } from './AddMetadataReferenceUserSelection.gql';
import { ListItemError } from './ListItemError';
import { ListSelection } from './ListSelection';
export function AddMetadataReferenceUserSelection(props) {
    const { isMultiSelect, label } = props;
    const { data, loading, error, refetch } = useQuery(AddMetadataReferenceUserSelectionDocument);
    const users = ((data === null || data === void 0 ? void 0 : data.users) || []).map((user) => ({ id: user.id, text: user.name || '', value: user.id }));
    if (error) {
        return <ListItemError label={label} onRefresh={refetch}/>;
    }
    return (<ListSelection reference={DocumentMetadataPropertyReferenceEnum.User} label={label} loading={loading} items={users} isMultiSelect={isMultiSelect}/>);
}
